// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"22269df1","845":"10d77646"}[chunkId] + ".chunk.js";
};